import { APIClient } from '../../infra/APIClient'
import { APIConfig, CursorPaged } from '../../types/definitions'
import {
  CreateWorkspacePostingPayload,
  WorkspacePostingsQuery,
  WorkspacePostingAggregationQuery,
  UpdateWorkspacePostingPayload,
} from './dtos/payloads'
import {
  WorkspacePostingDTO,
  WorkspacePostingAggregationDTO,
} from './dtos/workspace-posting'

export function createWorkspacePostingAPI(
  opts: APIConfig,
): WorkspacePostingAPI {
  return new WorkspacePostingAPI(opts)
}

export class WorkspacePostingAPI extends APIClient {
  create(
    workspaceId: string,
    payload: CreateWorkspacePostingPayload,
  ): Promise<WorkspacePostingDTO> {
    return this.client
      .post(`/v3/workspaces/${workspaceId}/postings`, payload)
      .then(this._data)
  }

  publish(id: string): Promise<void> {
    return this.client.patch(`/v3/postings/${id}/publish`).then(this._data)
  }

  markInReview(id: string): Promise<void> {
    return this.client.patch(`/v3/postings/${id}/review`).then(this._data)
  }

  get(id: string): Promise<WorkspacePostingDTO> {
    return this.client.get(`/v3/postings/${id}`).then(this._data)
  }

  updateDraft(
    id: string,
    payload: UpdateWorkspacePostingPayload,
  ): Promise<WorkspacePostingDTO> {
    return this.client.patch(`/v3/postings/${id}`, payload).then(this._data)
  }

  list(
    query: WorkspacePostingsQuery,
  ): Promise<CursorPaged<WorkspacePostingDTO>> {
    return this.client.get(`/v3/postings`, { params: query }).then(this._data)
  }

  getAggregation(
    query: WorkspacePostingAggregationQuery,
  ): Promise<Array<WorkspacePostingAggregationDTO>> {
    return this.client
      .get(`/v3/postings/aggregation`, { params: query })
      .then(this._data)
  }

  inviteApplicant(id: string, applicantPublicId: string): Promise<void> {
    return this.client
      .patch(`/v3/postings/${id}/invite`, {
        applicant_public_id: applicantPublicId,
      })
      .then(this._data)
  }

  rescindInvitation(id: string, applicantPublicId: string): Promise<void> {
    return this.client
      .patch(`/v3/postings/${id}/rescind-invitation`, {
        applicant_public_id: applicantPublicId,
      })
      .then(this._data)
  }

  reactivate(id: string): Promise<void> {
    return this.client.patch(`/v3/postings/${id}/reactivate`).then(this._data)
  }

  manuallyClose(id: string): Promise<void> {
    return this.client.patch(`/v3/postings/${id}/close`).then(this._data)
  }
}
